import React from "react";
import { default as MUIChip } from "@mui/material/Chip";

export const Chip = (props) => {
  return (
    <MUIChip
      {...props}
      sx={{
        minWidth: "88px",
        height: "20px",
        minHeight: "20px",
        maxHeight: "20px",
        padding: "1px 4px",
        textAlign: "center",
        overflow: "hidden",
        margin: "1px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        fontFamily: "var(--primaryTextFont)",
        fontSize: "14px",
        fontWeight: 400,
        border: "1px solid transparent",
        ...props.sx,
      }}
    />
  );
};
